import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import notify from 'devextreme/ui/notify';
import ValidationEngine from 'devextreme/ui/validation_engine';
import {take} from 'rxjs/operators';
import {FusionAuthService} from '../../../../shared/services/fusion-auth';
import {OrdersService} from '../../services/orders.service';
import {RequisitionService} from '../../services/requisition.service';

@Component({
  selector: 'app-email-fax-dialog',
  templateUrl: './email-fax-dialog.component.html',
  styleUrls: ['./email-fax-dialog.component.scss'],
})
export class EmailFaxDialogComponent {
  @Input() public popupVisible = false;
  @Input() public ids: number[] = [];
  @Input() public type = 'email';
  @Input() public from = 'order';
  @Output() public closeEvent = new EventEmitter();
  public isLoading = false;
  public emailFaxForm: UntypedFormGroup;
  public faxPattern: any = /^\d*$/;

  constructor(private fb: UntypedFormBuilder, private fusionAuthService: FusionAuthService, private orderService: OrdersService,
              private renderer: Renderer2, private elem: ElementRef, private requisitionService: RequisitionService) {
    this.emailFaxForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      fax: [null, [Validators.required, Validators.pattern]],
    });
  }

  public onTitleRendered(e: any) {
    const elements = (e.titleElement as HTMLElement).getElementsByClassName('dx-toolbar-items-container') as HTMLCollectionOf<HTMLElement>;
    if (elements) {
      if (elements.length > 0) {
        this.renderer.setStyle(elements.item(0), 'height', '54px');
      }
    }
  }

  public close(): void {
    this.emailFaxForm.reset();
    if (this.type === 'email') {
      ValidationEngine.resetGroup('emailValidationGroup');
    } else {
      ValidationEngine.resetGroup('faxValidationGroup');
    }
    this.closeEvent.emit();
  }

  public async save() {
    let validForm: any;
    if (this.type === 'email') {
      validForm = ValidationEngine.validateGroup('emailValidationGroup');
    } else {
      validForm = ValidationEngine.validateGroup('faxValidationGroup');
    }

    if (validForm.isValid) {
      this.isLoading = true;
      const transmission = {
        ids: this.ids,
        type: this.type,
        value: this.type === 'email' ? this.emailFaxForm.get('email')?.value : this.emailFaxForm.get('fax')?.value,
      };

      const request = this.from === 'order' ? this.orderService.sendTransmission(transmission) :
        this.requisitionService.sendTransmission(transmission);

      request.pipe(take(1)).subscribe(response => {
        if (response) {
          this.isLoading = false;
          notify('The ' + this.type + ' was sent successfully', 'success');
          this.close();
        }
      }, () => {
        notify('We are having trouble communicating with our servers!', 'error');
      });
    }
  }
}
